import React from 'react'
import Idea from '../components/Idea/IdeaInternal'

export default (props: any) => <Idea {...props} />
